// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCeF-FP22gvhaVP1z4lU7X29205ftjBKiA",
  authDomain: "eces-glossary.firebaseapp.com",
  projectId: "eces-glossary",
  storageBucket: "eces-glossary.appspot.com",
  messagingSenderId: "545235852853",
  appId: "1:545235852853:web:2b3671fc2cb766790d5b7c",
  measurementId: "G-FLFJN3L3BS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const facebook = new FacebookAuthProvider();

export { auth, provider, facebook };
